




















































import { Vue, Component, Prop } from "vue-property-decorator";
import { IUser } from "@/models/users";

@Component({
  components: {
    "user-provider": () =>
      import("@/components/app/admin/users/userProvider.vue")
  }
})
export default class AdminUserView extends Vue {
  // Props

  @Prop({ required: true })
  public userId!: IUser["id"];

  @Prop({ default: () => [] })
  public routes!: any[];

  // Life-cycle methods

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
}
